import React, { useState, useCallback, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import DeleteModal from "../common/delete-modal";
import RecordsPerPage from "../common/RecordsPerPage.jsx";

//API Imports
import { getAnnouncementData, getAnnouncementListApi } from "./announcement-api";

//SVG Images
import Search from "../../assets/svg/search.svg";
import Filter from "../../assets/svg/filters.svg";
import Plus from "../../assets/svg/add.svg";
import Dropdown from "../../assets/svg/dropdown.svg";
import Dots from "../../assets/svg/groupdots.svg";
import Customize from "../../assets/svg/customize.svg";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import Settings from "../../assets/svg/announcesettings.svg";
import Technology from "../../assets/svg/technology.svg";
import Mail from "../../assets/svg/announcemail.svg";
import Service from "../../assets/svg/service.svg";
import { ReactComponent as EditRow } from "../../assets/svg/edit.svg";
import { ReactComponent as DeleteRow } from "../../assets/svg/delete.svg";

const AnnouncementList = () => {
  //API URL
  const apiUrl = process.env.REACT_APP_API_URL;

  const options = ["Name", "Email", "Industry", "Message"];

  //Hovered Index
  const [hoveredIndex, setHoveredIndex] = useState(null);

  //Navigate
  const navigate = useNavigate();

  //Search
  const [search, setSearch] = useState("");

  //Create Calls Dropdown
  const [open, setOpen] = useState(false);

  //Customize Table Dropdown
  const [showModal, setShowModal] = useState(false);

  const [selectedColumns, setSelectedColumns] = useState(() => Object.fromEntries(options.map((label) => [label, true])));

  const toggleColumn = (label) => {
    setSelectedColumns((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const anyColumnSelected = Object.values(selectedColumns).some(Boolean);

  //Pagination
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [records, setRecords] = useState(0);

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % announcementList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}&skip=${itemOffset * itemsPerPage}`);
    setItemOffset(event.selected);
  }, []);

  //Get Announcement List
  const [announcementList, setAnnouncementList] = useState([]);

  const getAnnouncementList = async () => {
    try {
      const response = await getAnnouncementListApi(`?search=${search}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}`);
      if (response.data.success === true) {
        setPageCount(response.data.total_pgs);
        setRecords(response.data.total_rec);
        setAnnouncementList(
          response.data.enquiry.map((item) => ({
            id: item.id,
            Name: item.name,
            Email: item.email,
            Industry: item.industry,
            Message: item.message,
          }))
        );
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  useEffect(() => {
    getAnnouncementList();
  }, [search, itemsPerPage, itemOffset]);

  //Delete
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);

    // setSnackbarMessage(response.message);
    // setSnackbarStatus(response.success);
    // handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getAnnouncementList();
    }
  };

  // state
  const [selectedRows, setSelectedRows] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  // handle checkbox logic
  const toggleAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(announcementList.map((call) => call.id));
    }
    setAllSelected(!allSelected);
  };

  const toggleRow = (id) => {
    setSelectedRows((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  //view

  const [announcementData, setAnnouncementData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getAnnouncementData(selectedId);
        setAnnouncementData(data.data);
      } catch (e) {}
    }
    fetchData();
  }, [selectedId]);

  return (
    <div style={{ fontFamily: "'Euclid Circular B', sans-serif", padding: "16px", height: "100vh", width: "83vw", overflowX: "hidden", backgroundColor: "#f8f9fb" }}>
      {isOpenDelete && <DeleteModal deleteUrl={`enquiry/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div style={{ marginBottom: "32px" }}>
        <Row>
          <Col sm={12} md={6} lg={5}>
            <div style={{ fontWeight: "500", color: "#172b4d", fontSize: "20px" }}>Announcement - {records}</div>
          </Col>

          <Col sm={12} md={6} lg={3}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", borderRadius: "100px", border: "0.8px solid #e5e5e5", padding: "9px 16px", backgroundColor: "#ffffff", height: "40px" }}>
              <img src={Search} alt="search" style={{ width: "16px" }} />
              <input type="search" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} style={{ border: "none", outline: "none", fontSize: "14px", flex: 1, backgroundColor: "transparent" }} />
            </div>
          </Col>

          <Col sm={1} style={{ display: "flex", justifyContent: "center" }}>
            <img src={Filter} style={{ height: "40px" }} />
          </Col>

          <Col sm={2} md={6} lg={3} style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "8px 16px", borderTopLeftRadius: "100px", borderBottomLeftRadius: "100px", borderTopRightRadius: "100px", borderBottomRightRadius: "100px", borderBottom: "3px solid #1723C2", background: "linear-gradient(180deg, #6971DD 0%, #3D4AF5 100%)", height: "40px", width: "fit-content", cursor: "pointer" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }} onClick={() => navigate("/announcement/add")}>
                  <img src={Plus} style={{ width: "16px" }} alt="Plus" />
                  <div style={{ fontWeight: "600", fontSize: "16px", color: "#ffffff" }}>Create Announcement</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <Row>
          <Col sm={12}>
            <div style={{ borderRadius: "16px", border: "1px solid #ebebeb", backgroundColor: "#ffffff", overflowX: "auto", overflowY: "hidden", WebkitOverflowScrolling: "touch", scrollBehavior: "smooth" }} className="table-scroll-container">
              <div style={{ display: "flex", flexDirection: "column", minWidth: "min-content" }}>
              {/* Header */}

              <div style={{ display: "flex", alignItems: "center", width: "100%", borderBottom: "1px solid #ebebeb" }}>
                <div style={{ width: "72px", padding: "10px 24px", flexShrink: 0, borderRight: "1px solid #ebebeb" }}>
                  <input type="checkbox" checked={allSelected} onChange={toggleAll} />
                </div>

                <div style={{ display: "flex", flex: 1 }}>
                  {options.map((label, index) =>
                    selectedColumns[label] ? (
                      <div key={index} style={{ flex: 1, padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", borderRight: "1px solid #ebebeb" }}>
                        <div style={{ fontWeight: "500", fontSize: "15px", color: "#172b4d" }}>{label}</div>
                        <img src={Dots} alt="dots" />
                      </div>
                    ) : null
                  )}
                </div>

                <div onClick={() => setShowModal(true)} style={{ width: "72px", flexShrink: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={Customize} alt="customize" />
                </div>
              </div>

              {/* Data Rows */}
              {announcementList.map((call, rowIndex) => (
                <div key={"Announcement" + rowIndex} onMouseEnter={() => setHoveredIndex(rowIndex)} onMouseLeave={() => setHoveredIndex(null)} style={{ position: "relative", display: "flex", alignItems: "center", width: "100%", borderBottom: "1px solid #ebebeb", backgroundColor: "#ffffff" }}>
                  <div style={{ width: "72px", padding: "10px 24px", flexShrink: 0, borderRight: "1px solid #ebebeb" }}>
                    <input type="checkbox" checked={selectedRows.includes(call.id)} onChange={() => toggleRow(call.id)} disabled={!anyColumnSelected} />
                  </div>
                  <div
                    style={{ display: "flex", flex: 1 }}
                    onClick={() => {
                      setSelectedId(call.id);
                      setIsModalOpen(true);
                    }}>
                    {options.map((label, colIndex) =>
                      selectedColumns[label] ? (
                        <div key={colIndex} title={call[label]} style={{ flex: 1, padding: "10px 16px", fontSize: "14px", color: "#172b4d", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", borderRight: "1px solid #ebebeb" }}>
                          {call[label] || "-"}
                        </div>
                      ) : null
                    )}
                  </div>

                  {isModalOpen && (
                    <div style={{ position: "fixed", top: 0, right: 0, width: "35vw", height: "100%",overflowY:'auto', backgroundColor: "#ffffff", boxShadow: "2px 0 8px rgba(0,0,0,0.1)", transition: "transform 0.3s ease-in-out", transform: isModalOpen ? "translateX(0)" : "translateX(100%)", zIndex: 999 }}>
                      <div style={{ padding: "24px", backgroundColor: "#f8f8f8" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                          <div style={{ fontWeight: "700", fontSize: "24px", color: "#172b4d" }}>{announcementData.name}</div>

                          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <button
                              onClick={(e) => {
                                navigate("/announcement/add", { state: { id: selectedId } });
                              }}
                              style={{ height: "40px", border: "none", borderRadius: "100px", backgroundColor: "#3d4af5", padding: "8px 24px", lineHeight: "100%", fontWeight: "600", fontSize: "16px", color: "#ffffff" }}>
                              Edit
                            </button>
                            <img onClick={() => setIsModalOpen(false)} src={Settings} style={{ height: "40px" }} />
                          </div>
                        </div>

                        <div style={{ display: "flex", gap: "12px", alignItems: "center", marginBottom: "12px" }}>
                          <img src={Technology} style={{ height: "20px" }} />
                          <div style={{ fontWeight: "400", fontSize: "14px", color: "#3d4af5" }}>{announcementData.industry}</div>
                        </div>

                        <div style={{ display: "flex", gap: "12px", alignItems: "center", borderRadius: "12px", border: "1px solid #ebebeb", padding: "9px 12px", width: "fit-content", backgroundColor: "#ffffff" }}>
                          <img src={Mail} style={{ height: "18px" }} />
                          <div style={{ fontWeight: "400", fontSize: "14px", color: "#172b4d" }}>{announcementData.email}</div>
                        </div>
                      </div>

                      <div style={{ backgroundColor: "#ffffff", padding: "24px", display: "flex", flexDirection: "column", gap: "20px" }}>
                        <div style={{ fontWeight: "600", fontSize: "16px", color: "#172b4d" }}>Message</div>

                        <div style={{ fontWeight: "400", fontSize: "15px", color: "#172b4d" }}>{announcementData.message}</div>

                        <div style={{ fontWeight: "600", fontSize: "16px", color: "#172b4d", marginTop: "12px" }}>Selected Service</div>

                        <Row>
                          {announcementData.services?.map((service, index) => (
                            <Col lg={4} className="mb-3" key={index}>
                              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px", minWidth: "100px", borderRadius: "20px", padding: "12px", backgroundColor: "#f8f8f8" }}>
                                <img src={service.icon} alt={service.name} style={{ height: "40px" }} />
                                <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>{service.name}</div>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  )}

                  <div style={{ width: "72px", flexShrink: 0 }} />
                  {hoveredIndex === rowIndex && (
                    <div style={{ position: "absolute", top: "50%", right: "12px", transform: "translateY(-50%)", zIndex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/announcement/add", { state: { id: call.id } });
                          }}
                          style={{ display: "flex", alignItems: "center", border: "0.6px solid #E5E5E5", cursor: "pointer", justifyContent: "center", width: "32px", height: "32px", borderRadius: "100px", background: "#FFFFFF" }}>
                          <EditRow />
                        </div>
                        <span style={{ marginLeft: "16px" }}></span>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(call.id);
                          }}
                          style={{ display: "flex", alignItems: "center", border: "0.6px solid #E5E5E5", cursor: "pointer", justifyContent: "center", width: "32px", height: "32px", borderRadius: "100px", background: "#FFFFFF" }}>
                          <DeleteRow />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}

              {showModal && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
                  <div style={{ backgroundColor: "#fff", padding: "24px", borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0,0,0,0.2)", width: "300px", maxHeight: "80vh", overflowY: "auto" }}>
                    <div style={{ fontWeight: "600", fontSize: "16px", marginBottom: "16px" }}>Select Columns</div>
                    {options.map((label, index) => (
                      <label key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px", fontSize: "14px", cursor: "pointer" }}>
                        <input type="checkbox" checked={!!selectedColumns[label]} onChange={() => toggleColumn(label)} style={{ marginRight: "8px" }} />
                        {label}
                      </label>
                    ))}
                    <button onClick={() => setShowModal(false)} style={{ marginTop: "16px", width: "100%", padding: "10px", borderRadius: "8px", border: "none", backgroundColor: "#3D4AF5", color: "#fff", fontWeight: "500", cursor: "pointer" }}>
                      Close
                    </button>
                  </div>
                </div>
              )}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <Row>
          <Col>
            <RecordsPerPage
              value={itemsPerPage}
              onChange={(event) => {
                setItemsPerPage(event.target.value);
              }}
              labelStyle={{
                fontFamily: "Epilogue",
                color: "#212129",
              }}
              selectStyle={{
                fontFamily: "Epilogue",
                color: "#212129",
              }}
            />
          </Col>
          <Col>
            <div className="d-flex justify-content-end">
              <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AnnouncementList;
